import React, { useEffect, useState } from "react";
import OneWalletCommonModal from "./OneWalletCommonModal";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";

const PromotionOneWalletModal = ({ config = {}, isVisible, onClose, props = {} }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalConfig, setModalConfig] = useState({});
  const router = useRouter();
  const dispatch = useDispatch();

  // Synchronize internal state with the external `isVisible` prop
  useEffect(() => {
    console.log("isVisiblePromotionOneWalletModal", isVisible);
    setIsModalVisible(isVisible);
  }, [isVisible]);

  useEffect(() => {
    console.log("configPromotionOneWalletModal", config);
    if (Object.keys(config).length > 0) {
      console.log("configPromotionOneWalletModalParams", props);
      initializeModal(config, props);
    }
  }, [config, props?.campaignId]);


  const initializeModal = (config, props) => {
    let propsToCallback = {
      handleClose,
      router,
      dispatch,
    };
    console.log("initializeModalPromotionOneWalletModalprops", props);
    if (typeof props?.callback === "function") {
      console.log("callBackPromotionOneWalletModal", props.callback);
      propsToCallback = {
        ...propsToCallback,
        callback: props.callback,
      }
    }
    setModalConfig({
      content: typeof config.content === "function" 
      ? () => config.content(propsToCallback, props) // Pass handleClose to content
      : config.content || config.description,// Fallback to description if content is not provided
      primaryAction:  () => {
        console.log("Primary button clicked!");
        if (config.onButtonClick) {
          config.onButtonClick(propsToCallback, props); // Pass closeModal and router
        } else {
          handleClose();
        }
      },
      primaryLabel: config.buttonLabel || "OK",
      showPrimary: config.showPrimary,
      showSecondary: config.showSecondary || false,
      secondaryLabel: config.secondaryLabel || "Cancel",
      secondaryAction: () => {
        console.log("Secondary button clicked!");
        if (config.onSecondaryButtonClick) {
          config.onSecondaryButtonClick(propsToCallback); // Pass closeModal and router
        } else {
          handleClose();
        }
      },
      modalWidth: config?.modalWidth,
    });
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    // setIsModalVisible(false);
  };

  return (
    <div>
      <OneWalletCommonModal
        isVisible={isModalVisible}
        onClose={handleClose} // Pass handleClose to handle modal close
        {...modalConfig}
      />
    </div>
  );
};

export default PromotionOneWalletModal;
